import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api/thunkQuery';
import { IAuthResponse, IUserCredentials } from './types';

export const authorize = createAsyncThunk<IAuthResponse, IUserCredentials>(
	'/api/token/',
	async (userCredentials: IUserCredentials, { rejectWithValue }) => {
		return thunkAxiosRequest({
			method: 'post',
			path: '/api/token/',
			params: userCredentials,
			isApi: false,
			rejectWithValue,
		});
	},
);
